import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { doGetPromise } from '../../core/config/core.httpclient-utils';

@Injectable()
export class BuildService {

    private baseUrl = '/api/build';

    constructor(private http: HttpClient) {
        this.http = http;
    }

    fetch(unixName, queryParams: any = {}) {
        queryParams['project'] = unixName;
        return doGetPromise(
            this.http,
            this.baseUrl,
            queryParams
        );
    }

    getBuildSummary(unixName) {
        return doGetPromise(
            this.http,
            `/api/project/${ unixName }/builds`
        );
    }

    build(id) {
        return doGetPromise(
            this.http,
            this.baseUrl + `/${ id }`
        );
    }
}